import AppConfig from "Config/AppConfig";
import { store } from "Redux/Store";
import AuthenticationActions from "Redux/AuthenticationRedux";

const refreshApi = `${AppConfig.APIServer}users/refresh-token/`;

export const isTokenExpired = error => {
    return error.code === "token_not_valid";
}

export const resetTokenAndReattemptRequest = error => {

    // Get the refresh token
    const refreshToken = { refresh: store.getState().authentication.tokens.refresh };

    // Call the refresh API
    fetch(refreshApi, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: "POST",
        body: JSON.stringify(refreshToken)
    }).then(
        response => { 
            if(response.status === 200 || response.status === 201){

                // Add new access token to store
                store.dispatch(AuthenticationActions.refreshTokenSuccess({
                    ...response.data,
                    refresh: refreshToken
                }));

                // Reattempt the request
                const { originalError: { config } } = error;

                
                fetch(
                    config.url, 
                    {
                        method: config.method,
                    }
                ).then(
                    resp => console.log('Resp', resp)
                .catch(
                    e => console.log('Error', e)))


            } else {
                // What happens if the response fails...log them out?
                // store.dispatch(AuthenticationActions.refreshTokenFailure(response));
                // Log the user out
                store.dispatch(AuthenticationActions.logout());
            }
        }
    ).catch(e => { 
        console.log('Error', e);
        // Log the user out
        store.dispatch(AuthenticationActions.logout());
    })
}